import {
  ALL_FEATURES_VERDICTS,
  MVP_BOARD_VERDICTS,
  VERDICT_COLOR,
  VERDICT_DESCRIPTION,
  VERDICT_LABEL,
  type RoadmapBranch,
  type Verdict,
} from "@/presentation/data/roadmaps";

interface VerdictLegendProps {
  branch?: RoadmapBranch;
}

// Stable order for the universal legend (no branch selected).
const ALL_VERDICTS: readonly Verdict[] = [
  "mvp",
  "non-mvp",
  "off-the-shelf",
  "build-on-top",
  "from-scratch",
];

function LegendChip({ verdict }: { verdict: Verdict }) {
  return (
    <div
      data-slot="legend-chip"
      title={VERDICT_DESCRIPTION[verdict]}
      className="flex items-center gap-1.5"
    >
      <span
        className="inline-block size-2.5 rounded-full"
        style={{ background: VERDICT_COLOR[verdict] }}
      />
      <span className="text-[11px] font-medium">{VERDICT_LABEL[verdict]}</span>
    </div>
  );
}

export function VerdictLegend({ branch }: VerdictLegendProps) {
  const verdicts: readonly Verdict[] =
    branch === "all-features"
      ? ALL_FEATURES_VERDICTS
      : branch === "from-scratch"
        ? MVP_BOARD_VERDICTS
        : ALL_VERDICTS;
  return (
    <div
      data-slot="verdict-legend"
      className="flex flex-wrap items-center gap-x-4 gap-y-2 rounded-lg border border-[oklch(0.91_0.008_240)] bg-white px-4 py-2"
    >
      <span className="eyebrow !text-[9px]">Verdicts</span>
      {verdicts.map((v) => (
        <LegendChip key={v} verdict={v} />
      ))}
    </div>
  );
}
